import React from "react";

import ArrowLeft from "../../../../../features/cards-v2/components/actions/icons/ArrowLeft";

import {
  SettingsOptionBackButton,
  SettingsOptionBackContainer,
  SettingsOptionBackHeading,
} from "../styles";

const GoBack = ({ onClick = () => {}, content }) => {
  return (
    <SettingsOptionBackContainer>
      <SettingsOptionBackButton onClick={onClick}>
        <ArrowLeft />
      </SettingsOptionBackButton>
      <SettingsOptionBackHeading>{content}</SettingsOptionBackHeading>
    </SettingsOptionBackContainer>
  );
};

export default GoBack;
